import BaseService from "./base.service";

class UserService extends BaseService {
    constructor() {
        super();
        this.setBaseUrl("User");
    }

    async getIpAddress() {
        const response = await this.createPromiseRequest("ipaddress").get<string>();
        return response.data;
    }
}

export const userService = new UserService();

export default userService;
